// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  apiAddress: 'https://api-dev.globot.ai',
  apiAddressSockets: 'https://realtime-dev.globot.ai',
  datasourceRetryAttempts: 5,
  datasourceRetryIntervalTime: 5000,
  gdriveClientId: '1201299959-mdpv3l6t92o4bt649kksadcrshv1qkbh.apps.googleusercontent.com',
  isFacebookReady: true,
  isInstagramReady: true,
  isScanUrlReady: true,
  isLiveMessagingReady: true,
  facebookApiVersion: 'v22.0',
  facebookAppId: '1135983050786116',
  facebookAppSecret: '1af3fa614b916094b782c099f8c7c13b',
  messengerConfigId: 1390257869265448,
  instagramConfigId: 1442986277169638,
  whatsappConfigId: 801886929659200,
  subscriptionsEnabled: true,
  schedulingEnabled: true,
  showGlobotLive: false,
  // TEST plan ("Plan Prueba", id=5) visible in dev for payment-flow testing.
  showTestPlan: true,
  widgetUrl: 'https://widget-dev.globot.ai/demo/',
  demoTargetOrigin: 'https://widget-dev.globot.ai/',
  termsUrl: 'https://globot.ai/terminos-y-condiciones/',
  privacyUrl: 'https://globot.ai/politica-de-privacidad/',
  googleDeveloperKey: 'AIzaSyCAIH614O24npcu5e3vwnBmJeyEptjblCM',
  googleAppId: 'llmchatbot-388900',
  onesignalAppId: '5d5002ab-12a1-4c0c-b505-ee69a775db45',
  clarityId: 'vq1ehkb73p',
  gaId: '',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
